const messages = {
    fields: {
        first_name: 'Förnamn',
        last_name: 'Efternamn',
        address: 'Adress',
        postcode: 'Postnummer',
        city: 'Plats',
        phone: 'Telefonnummer',
        house_number: 'Husnummer',
        password: 'Lösenord',
    },
    customPages: {
        mainCategory: 'Huvudkategorier',
    },
    validations: {
        required: '{field} är obligatorisk',
        invalid: '{field} är felaktig',
    },
    blockCart: {
        addToCart: 'I kundvagn',
        addedToCartTitle: 'Tillagd i varukorgen',
        continueShopping: 'Fortsätt handla',
        proceedToCheckout: 'Kundvagn',
        productTotal: 'Totalt',
        showAllProducts: 'Visa alla produkter',
        cartShipping: 'Leverans',
        cartTotal: 'Totalt',
        close: 'Nära',
        addedToCartChoiceTitle: 'Ditt val:',
        noItemSelected: 'Ingen variant vald!',
        frequentlyBoughtTogether: 'Ofta köpta tillsammans'
    },
    myAccount: {
        titlePersonalInformation: 'Mina uppgifter',
        adjustData: 'Ändra data',
        setNewPassword: 'Ange nytt lösenord?',
        phoneNumberMessage: 'Leveransföraren kan kontakta dig',
        houseNumber: 'Nej',
        optional: 'Valfritt',
        currentPassword: 'Aktuellt lösenord',
        newPassword: 'Nytt lösenord',
        email: 'E-postadress',
        titleOrderHistory: 'Beställning',
        logout: 'Logga ut',
        loading: 'Laddning...',
        yourCart: 'Din kundvagn',
        address2: 'Ytterligare information',
        addAddress: 'Lägg till adress',
        defaultAddress: 'Standardadress',
        setAsDefaultAddress: 'Skapa standard',
        adjust: 'Justera',
        name: 'Namn',
        firstName: 'Förnamn',
        lastName: 'Efternamn',
        address: 'Adress',
        zipcode: 'Postnummer',
        residence: 'Bostad',
        country: 'Land',
        phone: 'Telefon',
        phoneNumber: 'Telefonnummer',
        copyAddress: 'Adress för kopiering',
        delete: 'Ta bort',
        errorMessage: 'Hoppsan! Fel hittades',
        cancel: 'Avbryt',
        save: 'Spara',
        packaging: 'Förpackning',
        unitPrice: 'Pris per enhet',
        price: 'Pris',
        totalPriceProducts: 'Totalt pris för beställd(a) produkt(er)',
        total: 'Totalt',
        freeOfCharge: 'Gratis',
        taxIncl: 'inkl. moms',
        continueToOrder: 'Til kassan',
        easyReorder: 'Beställ bara på nytt!',
        easyReorderMessage: 'Lägg till produkter från tidigare beställningar och gå till kassan.',
        emtpyOrderMessage:
            'När du har lagt en order visas den här med information om leveranstid, din faktura etc. Du kan också enkelt beställa om tidigare beställningar från denna sida.',
        emtpyOrderMessage2: 'Klicka på',
        emtpyOrderMessage3: 'här',
        emtpyOrderMessage4: ' för att gå till startsidan.',
        reorder: 'Ombeställning',
        products: 'Produkt(er)',
        totalShipmentCost: 'Leverans',
        shipmentCost: 'Leverans',
        status: 'Status',
        detailsInvoice: 'Detaljer och faktura',
        downloadInvoice: 'Ladda ner faktura ',
        shippedBy: 'Skickad av',
        paymentMethod: 'Betalningsmetod',
        deleteAddressModalText: 'Är du säker på att du vill radera den här adressen?',
        deleteAddressModalLoaderText: 'Upptagen med att radera?',
        errorModalText: 'Tyvärr, något gick fel',
        errorModalText2: 'Försök igen senare',
        appModalTitle: 'Brekz - Djuraffär på nätet - App',
        appModalText:
            'Vill du kunna beställa allt till ditt husdjur när som helst? Från och med nu kan du enkelt göra det via Brekz-appen.\n' +
            'Beställ enkelt tusentals produkter som mat, goda snacks och roliga leksaker på ett och samma ställe.',
        appModalText2: 'Du hittar appen i Play Store och App Store',
        appModalListTitle: 'Fördel',
        appModalListItem: '- Alltid din djuraffär till hands',
        appModalListItem1: ' - Enkel och snabb ombeställning',
        appModalListItem2: '- Bekväma meddelanden om beställningar och',
        appModalListItem3: '- Ställa in vilka / hur många aviseringar du vill få',
        appModalListItemLink: 'Alla erbjudanden',
        reorderModalSorry: 'Tyvärr slut i lager',
        reorderModalOutOfStock: 'inte längre tillgänglig',
        reorderModalPackaging: 'Följande förpackningar är ',
        reorderModalSkip: 'Hoppa över denna produkt',
        reorderModalAlternativesInStock: 'Alternativ i lager',
        reorderModalQuantity: 'Antal',
        pricePerUnit: 'Pris per styck',
        addProduct: 'lägg till',
        bundleDiscount: 'Fördel med paket',
        discount: 'Spara',
        reorderModalOrderAlternative: 'alternativ ordning',
        saveConfirmationModalTitle: 'Dina uppgifter lagras',
        minimumPurchaseMessage:
            'Minsta ordervärde är {amount} (exklusive fraktkostnader) Lägg till 1 eller flera produkter i din varukorg för att fortsätta.',
        trackAndTraceText: 'Spåra din beställning (tillgängligt efter att ditt paket har skickats)',
        noAlternativeProducts: 'Tyvärr finns det inga alternativa paket för din tidigare beställning',
        addressDescription: 'Här hittar du en översikt över dina adressuppgifter. Du kan också ändra dem här.\n',
        titleMyOrders: 'Mina beställningar',
        orderDescription: 'Kontrollera status för din beställning, din faktura eller gör en ny beställning\n',
        orderDescriptionShort: 'Kontrollera status för din beställning\n',
        addresses: 'Mina adresser',
        okay: 'Okej',
        errorFirstName: 'Förnamn saknas',
        errorLastName: 'Efternamn saknas',
        errorEmail: 'Kontrollera din e-postadress',
        errorPhone: 'Kontrollera ditt telefonnummer',
        errorAddress: 'Kontrollera gatunamn och husnummer',
        errorAddress2: 'Kontrollera gatunamn och husnummer',
        errorZipcode: 'Postnummer felaktigt:',
        errorCity: 'Kontrollera din hemstad',
        errorPassword: 'Lösenord saknas eller är för kort',
        eraseWarning: 'Du håller på att radera alla inmatade data!',
        eraseConfirmation: 'Är du säker på det?',
        amount: 'Antal',
        orderDate: 'Datum för beställning',
        trackAndTrace: 'Track & Trace',
        close: 'Nära',
        toCart: 'Till kundvagnen',
        productsInCart: 'Produkter har lagts till i din varukorg',
        orderInCart: 'Din beställning har lagts till i din varukorg',
        productsInColumn:
            'Du hittar dem i högerspalten på den här sidan, eller klicka på ikonen för kundvagnen längst upp till höger på sidan',
        orderStatus: 'Status för din beställning',
        orderProcess: 'Din beställning går i de flesta fall igenom följande steg:',
        paymentWaiting: 'Väntar på betalning',
        paymentReceived: 'Erhållen betalning',
        orderCollected: 'Ordern har samlats in',
        orderSent: 'Din beställning har skickats',
        followOrder: 'Du kan nu spåra ditt paket via ',
        followOrderEnd: '.',
        multiplePackages: 'Obs: Beställningen innehåller flera paket',
        trackAndTraceActiveTime: 'OBS: det kan ta ett tag innan länken blir aktiv',
        delivered: 'Bekymrad',
        password: 'Lösenord',
        didYouMean: 'Du kanske menar',
        apply: 'Tillämpa',
        bundle: 'Paket',
        bundlePriceWas: 'Tvätta',
        saving: 'Spara',
    },
    checkout: {
        between: '',
        and: '-',
        days: "arbetsdagar",
        delivery: 'Leverans',
        countdownMessage1: 'Beställ inom',
        countdownMessage2: 'för snabbast leverans',
        newCard: 'Använda ett nytt kreditkort',
        creditCard: 'Kreditkort',
        addNewCard: 'Lägg till ny {card}',
        passwordMessage: 'Minst 5 tecken',
        loading: 'Laddning...',
        lastStep: 'Sista steget',
        savedCard: 'Använda sparade {card}',
        cardNumber: 'Kortnummer',
        otherCard: 'Använd andra {card}',
        expireDate: 'Sista giltighetsdag',
        errorCard: 'Detta kort är inte giltigt eller stöds inte',
        errorName: 'Nuvarande namn är inte giltigt',
        errorDate: 'Aktuellt utgångsdatum är inte giltigt eller har löpt ut',
        errorCVV: 'Nuvarande namn är inte giltigt',
        cardExpired: 'Detta kort har gått ut i vårt system. Vänligen ange kortet igen.',
        saveCard: '{card} spara',
        nextTime: 'för nästa gång',
        order: 'Beställning',
        back: 'Tillbaka till betalningsalternativ',
        addressEdit: 'Redigera adress',
        paymentSucces: 'Din betalning har mottagits framgångsrikt',
        backToOrderhistory: 'Du kommer att omdirigeras till din orderöversikt inom några sekunder.',
        bancontactNotAvailable: 'Bancontact är inte tillgängligt på ',
        allData: 'Alla dina data är ',
        secured: 'säker',
        almostDone: 'Nästan klar',
        banContactNotAvailable: 'Bancontact är inte tillgängligt på',
        payWith: 'Ta itu med din',
        bancontactApp: 'Bancontact app',
        useOtherBancontact: 'Använda andra Bancontact',
        useNewBancontact: 'Använda ny Bancontact',
        addNewBancontact: 'Lägg till ny Bancontact',
        payWithBancontactApp: 'Betala med bancontact-appen',
        openBancontactApp: 'Öppna bancontact-appen och skanna koden för att slutföra betalningen med appen',
        noBancontactApp: 'Har du inte appen? Använd då metoden här intill.',
        mistercacheSave: 'Bancontact opslaan',
        cardHolderNamePlaceholder: 'Sven Svensson',
        newAccount: 'Vart kan paketet ta vägen?',
        cancel: 'Avbryt',
        taxIncl: 'inkl. moms',
        total: 'Totalt',
        name: 'Namn',
        close: 'Nära',
        errorText: 'Tyvärr, något gick fel',
        errorModalText: 'Tyvärr, något gick fel under betalningen',
        errorModalText2: 'Försök igen senare',
        rememberAddressHeaderTitle: 'Spara tid på ditt nästa köp',
        rememberAddressSwitchLabel: 'Använd denna adress och betalningsalternativ vid efterföljande beställningar',
        paymentSecurityText: 'Alla dina data är',
        paymentSecurityTextBold: 'säker',
        paymentCardHeaderTitle: 'Betalningsalternativ',
        addressCardHeaderTitle: 'Leveransadress',
        invoiceAddress: 'Faktureringsadress',
        editAddress: 'Justera',
        addNewAddress: 'Lägg till ny adress',
        addNewInvoiceAddress: 'Lägg till ny faktureringsadress',
        addressMatchesInvoiceAddress: 'Faktureringsadressen är inte densamma som leveransadressen',
        addressMatchesNotInvoiceAddress: 'Faktureringsadressen är inte densamma som leveransadressen',
        // checkout progressbar
        progressbarLogIn: 'Logga in',
        progressbarPaymentOption: 'Betalningsalternativ',
        progressbarPayment: 'Betalning',
        progressbarDone: 'Klart!',
        klarnaPhoneNumberRequiredModal: {
            modalMessage: 'Du har valt att betala med Klarna. Detta kräver ditt telefonnummer.',
            phoneNumberInputField: 'Kontrollera ditt telefonnummer',
            otherPaymentMethod: 'Andere betaalmethode kiezen',
        },
        validationErrors: {
            noPaymentMethodSelected: 'Du har ännu inte valt någon betalningsmetod',
            noAddressSelected: 'Du har ännu inte valt en leverans- och/eller faktureringsadress',
            paymentMethodRequiresPhoneNumber:
                'Ditt telefonnummer saknas i dina adressuppgifter. Lägg till detta för att kunna betala med Klarna',
            termsOfServices: 'Du måste godkänna de allmänna villkoren',
            noDeliveryOnThisAddress:
                'Tyvärr levererar vi inte till det postnummer du angett. När du beställer kan du välja att paketet ska levereras till ett annat postnummer.',
        },
        processWaiting: {
            title: 'Betalningen är genomförd',
            description: 'Ett ögonblick, tack.',
        },
    },
    address: {
        placeholderFirstname: 'Sven',
        placeholderLastname: 'Nilsson',
        placeholderAddress: 'Roslagsgatan',
        placeholderAddress2: 'Bussnummer, våning, företagsnamn etc.',
        placeholderZipcode: '113 51',
        placeholderCity: 'Stockholm',
        placeholderPhone: '0612345678',
        noShipping:
            'På ditt valda postnummer tillkommer tyvärr extra fraktkostnader. För att undvika dessa kostnader kan du få paketet levererat till ett annat postnummer.',
    },
    outOfStockNotificationOptin: {
        modalTitle: 'Håll mig informerad',
        modalMessage: 'Du kommer att få ett engångsmejl så snart produkten åter finns i lager.',
        modalSubmitButton: 'Håll mig informerad',
        email: 'E-postadress',
        placeholderEmail: 'exempel@email.se',
        noAbuse: 'Din e-postadress kommer inte att användas för andra ändamål.',
        alreadySignedUp: 'Du är redan registrerad för denna produkt.',
        invalidEmail: 'Ogiltig e-postadress',
        genericError: 'Något gick fel',
    },
    orderConfirmation: {
        modalTitle: 'Vill du kunna spåra din beställning?',
        modalMessage:
            'Du har beställt<b> som en </b>gäst. Vänligen lägg till ett <b>lösenord</b> och följ <b>din beställning</b> i orderöversikten för ditt personliga konto.',
        enterPassword: 'Lägg till lösenord',
        minimumWarning: 'Minst 5 tecken',
        passwordTooShort: 'Det angivna lösenordet är för kort',
        somethingWentWrong: 'Ett allmänt fel uppstod',
    },
    unsubPage: {
        emailQuestion: 'För vilken e-postadress?',
        emailKnown: 'E-postadress från ditt konto: ',
        emailadres: 'E-postadress:',
        changeEmailSettings: 'Anpassa inställningar för e-post ',
        iWant: 'Jag vill',
        iWant2: 'Jag vill',
        keepProfiting: 'fortsätta att dra nytta av ',
        ofTheBenefitMail: 'av e-postmeddelandet om förmånen',
        sendMe: 'Skicka mig',
        onesEvery2Weeks: 'en gång varannan vecka',
        exclusiveOffersAndTheBestDiscounts: 'exklusiva erbjudanden och bästa rabatter',
        onetimeAMonth: 'en gång i månaden',
        wellEnoughButDontMiss: 'är tillräckligt, men jag vill inte missa en fördel',
        noBenefit: 'För mig finns inga fler förmåner,',
        writeMeOut: 'Jag avslutar prenumerationen',
        benefitMail: 'Fördel e-post',
        birthdayMail: 'Födelsedag e-post',
        tipsAndAdvice: 'Tips och råd',
        personalDiscount: 'Personliga rabatter',
        productReviewAndReviews: 'Produktbetyg och recensioner',
        stillReceiveUpdatesAboutDelivery:
            'Du kommer naturligtvis fortfarande att få uppdateringar om din beställning och leverans',
        feedBackAndTips: 'Har du några tips eller synpunkter till oss?',
        cancel: 'Avbryt',
        benefitDogCat: 'Lägg till förmåner för hund eller katt?',
        iWantBenefitFor: 'Jag skulle vilja ha förmåner för',
        dogs: 'Hundar',
        cats: 'Katter',
        dogsAncCats: 'Hundar och katter',
        no: 'nej',
        receiveMoreBenefitFor: 'få mer förmåner för',
        giveMe: 'Ge mig',
        allBenefit: 'alla fördelar',
        average2MailsAWeek: '(i genomsnitt 2 e-postmeddelanden om förmåner per vecka)',
        oneTime2Weeks: '1 gång varannan vecka',
        save: 'Spara',
        received: '',
        selectVariant: 'Välj variant',
        YouAreSuccessfullyUnsubscribedFor: 'Du har framgångsrikt avslutat din prenumeration:',
        checkYourEmail: 'Kontrollera din e-postadress',
        noOptionSelected: 'Inget alternativ valt',
    },
    algoliaSearch: {
        mqc: {
            max: 'Max',
            perCustomer: 'Per kund',
        },
        searchButton: 'Sök',
        searchPlaceholder: 'Skriv din sökfråga här',
        searchBarInputPlaceholder: 'Sök bland mer än 6 000 produkter',
        searchBarInputPlaceholderApp: '6000+ produkter',
        noResultsContentTitleCategory: 'Tyvärr hittades inga produkter med de valda filtren.',
        noResultsContentTitle:
            'Vi kunde inte hitta <b>inga resultat</b> för <span class="algolia-listing-no-results__content-title--brand">"{query}"</span>',
        noResultsContentListTitle: 'Vad du kan göra:',
        noResultsContentListItemOne: 'Kontrollera stavningen i din sökning',
        noResultsContentListItemOneCategory: 'ta bort ett eller flera filter',
        noResultsContentListItemTwo:
            'Letade du efter ett varumärke? Tyvärr har vi (ännu) inte detta märke i vårt sortiment',
        noResultsContentListItemTwoCategory: 'Klicka på Ta bort alla för att starta ett nytt urval',
        noResultsContentListItemThree: 'Försök med en annan sökning',
        noResultsWithQuery: 'Inga förslag hittades för <b>"{query}"</b>',
        searchHistoryTitle: 'Tidigare sökt av dig',
        searchResultsHeader: '<b>{resultCount}</b> Sökresultat för <b>"{query}"</b> i alla artiklar.',
        searchResultsHeaderSubtitle: 'Förfina dina resultat med hjälp av filtren nedan.',
        searchResultsTitle: 'Sökförslag',
        popularProductsTitle: 'Favoriter',
        popularCategoriesTitle: 'Populära kategorier',
        queryMirrorTitle: 'Din sökning',
        resultsHitsProducts: 'Produkter',
        resultsHitsDelete: 'Rensa alla',
        resultsHitsFilter: 'Filter',
        resultsHitsFilterNote: 'Använd filtren för att snabbare hitta det du söker',
        fiterPanelMobileHeaderTitle: 'Filter',
        fiterPanelMobileHeaderSubtext: 'Använd filtren för att snabbare hitta det du söker',
        fiterPanelMobileDeleteFilters: 'Rensa alla',
        fiterPanelMobileFilteredProductAmount: 'produkter',
        fiterPanelMobileSaveSelection: 'Spara urval',
        fiterPanelMobileFooterTextPartOne: 'Filter',
        fiterPanelMobileFooterTextPartTwo: 'resultat',
        hitItemFromLabel: 'från:',
        hitItemViewProduct: 'Visa produkter',
        refinementListViewMore: 'Mer...',
        refinementListViewLess: 'Mindre...',
        refinementListRangeBoxInbetween: 'till',
        unAvailableNotePartOne: 'vid',
        unAvailableNotePartTwo: 'tillgänglig igen',
        filters: {
            priceReduction: {
                on: 'Ja',
                off: 'Nej',
            },
        },
    },
    algoliaRecommend: {
        recommendedProducts: 'Liknande produkter',
        recommendedProductsSubtitle: 'Annorlunda, men också toppen!',
        boughtTogether: 'Ofta köpta tillsammans',
        boughtTogetherSubtitle: 'Allt klart på en gång!'
    },
    mobileMenu: {
        makeYourChoice: 'Gör ditt val',
    },
    combinationPromotion: {
        op: 'ON = PÅ',
        bonus: 'Bonusväska',
        twoPlusOneFree: '2 + 1 Gratis',
        minusTenPercent: '-10%',
        minusTwentyPercent: '-20%',
        minusTwentyFivePercent: '-25%',
        minusThirtyPercent: '-30%',
        minusFortyPercent: '-40%',
        minusFiftyPercent: '-50%',
        minusSixtyPercent: '-60%',
        minusSeventyPercent: '-70%',
    },
    resetPassword: {
        passwordError: 'Lösenorden stämmer inte överens',
        passwordForgot: 'Har du glömt ditt lösenord?',
        createNewPassword: 'Skapa nytt lösenord',
        description:
            'Ange e-postadressen till ditt konto. Vi kommer att skicka en länk till denna e-postadress för att du ska kunna ange ett nytt lösenord.',
        email: 'E-postadress',
        note: 'Det kan ta en stund innan du får länken. Vänta minst 4 minuter innan du begär en länk igen. På så sätt undviker du att få en länk som inte fungerar. ',
        setNewPassword: 'Ange nytt lösenord',
        chooseNewPassword: 'Välj ditt lösenord',
        newPassword: 'Nytt lösenord',
        reenterPassword: 'Ange ditt nya lösenord igen',
        passwordsDontMatch: 'Lösenordet i fält 2 är inte lika med fält 1',
        passwordsDontMatchError: 'Lösenorden stämmer inte överens',
        submit: 'Skicka',
    },
};
export default messages;
